





























export default

	props: block: Object

	computed:

		# Apply max-width choice
		classes: -> @block.maxWidth

